import Avatar from '../Avatar'

import './style.scss'

type AvatarGroupProps = {
  users?: any[]
}

const AvatarGroup = ({ users }: AvatarGroupProps) => {
  const previewUsers = users.slice(0, 4)

  return (
    <div className={`AvatarGroup AvatarGroup--user-${previewUsers.length}`}>
      {previewUsers.map((user) => (
        <Avatar
          key={user.id}
          className="AvatarGroup__avatar"
          user={user}
          placeholderImage="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mN8+h8AAs8B5qzsEekAAAAASUVORK5CYII="
        />
      ))}
    </div>
  )
}

export default AvatarGroup
